import axios from 'axios'

export const listAmenityCatalogService = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/amenity/catalog`)
        return response?.data
    } catch (error) {
        console.log(error)
        return false
    }
}

export const listMyPlaceAmenitiesService = async (user_access_key) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/amenity/my_place/${user_access_key}`)
        return response?.data
    } catch (error) {
        console.log(error)
        return false
    }
}

export const linkAmenityService = async (user_access_key, amenity_id) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/amenity/link`, {
            user_access_key,
            amenity_id,
        })
        return response?.data === true
    } catch (error) {
        console.log(error)
        return false
    }
}

export const unlinkAmenityService = async (user_access_key, amenity_id) => {
    try {
        const response = await axios.delete(
            `${process.env.REACT_APP_API_URL}/api/amenity/link/${user_access_key}/${amenity_id}`
        )
        return response?.data === true
    } catch (error) {
        console.log(error)
        return false
    }
}
